import React from 'react'
import { useIntl, FormattedMessage } from 'react-intl'
import { rem } from 'polished'
import Group from 'components/utils/Group'
import LayoutContainer from 'components/Common/LayoutContainer'
import TrackedCardCarousel from 'components/Common/TrackedCardCarousel/TrackedCardCarousel'
import CruiseDestinationsSectionItem from './CruiseDestinationsSectionItem'
import TrackingContext from 'contexts/trackingContext'
import qs from 'qs'
import Heading from 'LuxKit/Typography/Heading'

const DESTINATION_DATA = [
  {
    destination: 'Sydney',
    image: { id: 'v4kwli3fa6d30n2w1rk9' },
    filter: qs.stringify({
      destinationIds: 'le_acf06cdd9c744f969958e1f085554c8b',
      destinationNames: 'Sydney',
    }),
  },
  {
    destination: 'Brisbane',
    image: { id: 'e3shvrl7vnuw84mb3fbj' },
    filter: qs.stringify({
      destinationIds: 'le_67e103b0761e60683e83c559be18d40c',
      destinationNames: 'Brisbane',
    }),
  },
  {
    destination: 'Melbourne',
    image: { id: '3wgitcdr0mdfwtfa02ve' },
    filter: qs.stringify({
      destinationIds: 'le_bbaa9d6a1445eac881750bea6053f564',
      destinationNames: 'Melbourne',
    }),
  },
  {
    destination: 'Italy',
    image: { id: 'wbk1yjnf56awezs1lu' },
    filter: qs.stringify({
      destinationIds: 'le_93db85ed909c13838ff95ccfa94cebd9',
      destinationNames: 'Italy',
    }),
  },
  {
    destination: 'Greece',
    image: { id: 'la8fpc5ehwxlh9cyd9ne' },
    filter: qs.stringify({
      destinationIds: 'le_735b90b4568125ed6c3f678819b6e058',
      destinationNames: 'Greece',
    }),
  },
  {
    destination: 'South Pacific',
    image: { id: 'k9ms6hbvzrnln6o4oluc' },
    filter: qs.stringify({
      destinationIds: 'le_a8697c7e6e7988b29a9de094b8d554cc',
      destinationNames: 'South Pacific',
      cruiseLines: ['RCC', 'NCL', 'CEL'],
    }, { indices: false }),
  },
]

function CruisePageDestinationTiles() {
  const intl = useIntl()

  const locations = DESTINATION_DATA.map((location) => ({
    ...location,
    name: intl.formatMessage(
      {
        id: 'MIDBHycAUBOWzyBt3C69',
        defaultMessage: '{destination} Cruises',
        description: 'Tile heading for cruises to a specific destination',
      },
      { destination: location.destination },
    ),
  }))

  const viewOffersLabel = intl.formatMessage({
    id: 'pBWBnTLrBfCsDhpRiekY',
    defaultMessage: 'View offers',
    description: 'Call to action button text to view cruise offers for a destination',
  })

  return (
    <TrackingContext.Provider
      value={{
        category: 'cruise_destinations',
        label: 'Cruise Page Destinations',
        listId: 'cruise-destinations-carousel',
        listName: 'Cruise Page Destinations',
      }}
    >
      <Group gap={32} direction="vertical">
        <LayoutContainer>
          <Heading variant="heading3">
            <FormattedMessage
              id="BZPJSyfsuwraI_lmSxRj"
              defaultMessage="Popular cruise <i>destinations</i>"
              description="Section heading for popular cruise destinations in the cruises section"
              values={{ i: (chunks) => <i>{chunks}</i> }}
            />
          </Heading>
        </LayoutContainer>

        <LayoutContainer>
          <TrackedCardCarousel pageSize={6} width={rem(180)}>
            {locations.map((location, index) => (
              <CruiseDestinationsSectionItem
                key={location.image.id}
                destination={location}
                position={index}
                href={`/search/cruises?${location.filter}`}
                image={location.image}
                heading={location.name}
                subHeading=""
                align="top"
                callToAction={viewOffersLabel}
              />
            ))}
          </TrackedCardCarousel>
        </LayoutContainer>
      </Group>
    </TrackingContext.Provider>
  )
}

export default CruisePageDestinationTiles
